import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import Breadcrumbs from './components/bread_crumbs'
import {store} from './store';
import Vue2Filters from 'vue2-filters'
import VueSweetalert2 from 'vue-sweetalert2';
import VueFormWizard from 'vue-form-wizard';
import VueTour from 'vue-tour'
import VueI18n from 'vue-i18n';
import Toasted from 'vue-toasted';
import SmartTable from 'vuejs-smart-table'
import VueFeather from 'vue-feather';
import VueSocialSharing from 'vue-social-sharing'
import VueCountdownTimer from 'vuejs-countdown-timer';
import en from './locales/en.json';
import ru from './locales/ru.json'
import az from './locales/az.json'
import money from 'v-money'

import {Calendar, DatePicker} from 'v-calendar';

import JsonExcel from "vue-json-excel";
// Import Theme scss
import './assets/scss/app.scss'

import messaging from './firebase'
import VeeValidate from 'vee-validate';

// config for firebase

Vue.use(VueFeather);

Vue.use(Toasted, {
    iconPack: 'fontawesome'
});
Vue.use(VeeValidate);

Vue.prototype.$messaging = messaging

function handleMessage(payload) {
    // Let's check whether notification permissions have already been granted
     if (Notification.permission === "granted") {
        let notification = new Notification(payload.notification.title, {
            body: payload.notification.body,
            icon: '/logo.png'
        });
        notification.onclick = function (event) {
            event.preventDefault();
            window.focus();
            window.location.href = '/dashboard/welcome';
            notification.close();
        }
    }
}

try {
    messaging.onMessage((payload) => {
        handleMessage(payload)
    });
} catch (e) {
}

Vue.use(Vue2Filters)
Vue.use(VueSweetalert2);
Vue.use(VueFormWizard)
Vue.use(VueTour)
Vue.use(BootstrapVue)
Vue.use(SmartTable)
Vue.use(VueSocialSharing)
Vue.use(VueI18n);
Vue.use(VueCountdownTimer)
Vue.use(money, {precision: 2})
Vue.use(require('vue-moment'));
Vue.use(require('vue-chartist'))
Vue.component('Breadcrumbs', Breadcrumbs)
Vue.component('Calendar', Calendar)
Vue.component('DatePicker', DatePicker)
Vue.component("downloadExcel", JsonExcel);
Vue.config.productionTip = false
const messages = {
    az: az,
    en: en,
    ru: ru
}
export const i18n = new VueI18n({
    locale: localStorage.getItem('userLang') || 'az', // Use stored locale or fallback to 'az'
    messages
});
new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app')
